import { ListAlt } from '@mui/icons-material';
import { Box, IconButton, Tooltip } from '@mui/material';
const columnShape = [
    {
        Header: "Workshop Name",
        accessor: "name"
    }, 
    {
        Header: "Workshop Type",
        accessor: "type.label"
    }, 
    {
        Header: "Capacity",
        accessor: "capacity",
        Cell: ({ value }) => value ?? "-"
    },
    {
        Header: "Individu Paid",
        accessor: "paidInvoiceCount"
    },
    {
        Header: "Individu Waiting",
        accessor: "pendingInvoiceCount"
    },
    {
        Header: "Group Invoiced",
        accessor: "groupInvoicedCount"
    },
    {
        Header: "Group GL Uploaded",
        accessor: "groupGLUploadedCount"
    },
    {
        Header: "Action",
        accessor: "id",
        Cell: ({row, handleDownload, handleDetail}) => {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Tooltip title="Detail Participant">
                        <IconButton
                            onClick={() => handleDetail(row.original)}
                            sx={{
                                color: "text.disabled",
                                fontSize: 18,
                            }}
                        >
                            <ListAlt />
                        </IconButton>
                    </Tooltip>
                </Box>
            )
        }
    }
];
export default columnShape;
